import { styled } from 'styled-components';
import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';

import { StyledProductTitle } from './order-details.styled';

export const StyledDetailsTitle = styled(StyledProductTitle)`
  flex-basis: 50%;
`;

export const StyledText = styled(Typography)`
  flex-basis: 50%;
  text-align: right;
`;
